import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionProgressLogsService } from '../services/constructionProgressLogs.service';
import { ConstructionProgressPhotosService } from '../services/constructionProgressPhotos.service';
import type { ConstructionProgressLog } from '../types/construction-progress.types';
import { toast } from 'sonner';

export function useConstructionProgressDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-progress-logs', 'detail', id],
    queryFn: () => ConstructionProgressLogsService.getProgressLogDetail(id!),
    enabled: !!id,
  });

  const photosQuery = useQuery({
    queryKey: ['construction-progress-logs', 'photos', id],
    queryFn: () => ConstructionProgressPhotosService.getProgressPhotos(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionProgressLog>) => ConstructionProgressLogsService.updateLog(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-progress-logs'] });
      queryClient.invalidateQueries({ queryKey: ['construction-progress-logs', 'detail', id] });
      toast.success('Cập nhật tiến độ thành công');
    },
  });

  return {
    log: query.data,
    photos: photosQuery.data || [],
    isLoading: query.isLoading || photosQuery.isLoading,
    updateLog: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
